@charset "UTF-8";

/* src/app/features/modalidade-scr/cadastro/modalidade-scr-cadastro.component.scss */
/*# sourceMappingURL=modalidade-scr-cadastro.component.css.map */
